export default __webpack_public_path__ + "static/media/logo.52c3c0d7.png";